import React from 'react';
import Slider from 'components/Slider';
import withSetting from './SettingsHOC';

function ConfigurationSlider(props) {
  const { min, max } = props.schema.validationSchema['isInt'];
  const { onChange, value } = props;

  return <Slider min={min} max={max} value={value} onChange={onChange} />;
}

export default withSetting(ConfigurationSlider);
